import React, { useState } from "react";
import axios from "axios";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import Constant from "../Constant";

const CreateFeatureModal = ({
  open,
  onClose,
  onFeatureCreated,
  showNotification,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    isActive: true,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axios.post(
        `${Constant.apiBasePath}features`,
        formData
      );

      showNotification("Feature created successfully");
      onFeatureCreated();
      onClose();
    } catch (error) {
      if (error.response && error.response.data) {
        showNotification(error.response.data.message, "error");
      } else {
        showNotification("Failed to create feature", "error");
      }
      console.error("Error creating feature:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const modalStyle = {
    formGrid: {
      display: "grid",
      gridTemplateColumns: "1fr",
      gap: "16px",
    },
    formGroup: {
      marginBottom: "16px",
    },
    input: {
      width: "100%",
      padding: "8px",
      border: "1px solid #ddd",
      borderRadius: "4px",
    },
    textarea: {
      width: "100%",
      padding: "8px",
      border: "1px solid #ddd",
      borderRadius: "4px",
    },
    label: {
      display: "block",
      marginBottom: "6px",
      fontWeight: "500",
    },
    checkboxLabel: {
      display: "flex",
      alignItems: "center",
      marginBottom: "8px",
    },
    buttonGroup: {
      display: "flex",
      justifyContent: "flex-end",
      gap: "10px",
      marginTop: "16px",
    },
    button: {
      padding: "8px 16px",
      borderRadius: "4px",
      cursor: "pointer",
    },
    submitButton: {
      backgroundColor: "#4a90e2",
      color: "white",
      border: "none",
    },
    cancelButton: {
      backgroundColor: "#f5f5f5",
      border: "1px solid #ddd",
    },
    modalContent: {
      padding: "20px",
      maxWidth: "500px",
      maxHeight: "80vh",
      overflow: "auto",
    },
  };

  return (
    <Popup
      open={open}
      onClose={onClose}
      contentStyle={{ maxWidth: "500px", width: "80%" }}
      modal
      nested
    >
      <div style={modalStyle.modalContent}>
        <h2 style={{ marginBottom: "20px", textAlign: "center" }}>
          Create New Feature
        </h2>
        <form onSubmit={handleSubmit}>
          <div style={modalStyle.formGrid}>
            <div style={modalStyle.formGroup}>
              <label style={modalStyle.label}>
                Feature Name:
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  style={modalStyle.input}
                />
              </label>
            </div>

            <div style={modalStyle.formGroup}>
              <label style={modalStyle.label}>
                Description:
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  rows="3"
                  style={modalStyle.textarea}
                />
              </label>
            </div>

            <div style={modalStyle.formGroup}>
              <label style={modalStyle.checkboxLabel}>
                <input
                  type="checkbox"
                  name="isActive"
                  checked={formData.isActive}
                  onChange={handleChange}
                  style={{ marginRight: "8px" }}
                />
                Active
              </label>
            </div>

            <div style={modalStyle.buttonGroup}>
              <button
                type="button"
                onClick={onClose}
                style={{ ...modalStyle.button, ...modalStyle.cancelButton }}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                style={{ ...modalStyle.button, ...modalStyle.submitButton }}
              >
                {isSubmitting ? "Creating..." : "Create"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </Popup>
  );
};

export default CreateFeatureModal;
